import React from 'react';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@actual-app/components/text';
import { theme } from '@actual-app/components/theme';

/**
 * El lema de Rumbo, «Tu dinero · tus decisiones · tu rumbo» (B8 · H86,
 * H34): versalitas discretas bajo la marca. Lo comparten la bienvenida, el
 * inicio de sesión y Ajustes › Acerca de.
 */
export function Lema({
  style,
  'data-testid': testId = 'lema',
}: {
  style?: CSSProperties;
  'data-testid'?: string;
}) {
  const { t } = useTranslation();
  return (
    <Text
      data-testid={testId}
      style={{
        color: theme.pageTextSubdued,
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.16em',
        textTransform: 'uppercase',
        ...style,
      }}
    >
      {t('Your money · your decisions · your course')}
    </Text>
  );
}
